import React from 'react';
import { Link, MemoryRouter } from 'react-router-dom';
import styles from './NavLink.module.css';

const NavLink = props => {
  const { title, route } = props;

  return (
    <Link
      className={ styles.NavLink }
      to={ route }
    >
      { title }
      { props.children }
    </Link>
  );
};

export default NavLink;
